module.exports = __webpack_public_path__ + "img/deepseek-logo@3x.ffad82c7.png";